(() => {
  const data = document.getElementById('knots-products');
  const drawer = document.getElementById('drawer');
  const scrim = document.getElementById('scrim');
  if (!data || !drawer || !scrim) return;

  let ITEMS = [];
  try { ITEMS = JSON.parse(data.textContent); } catch (e) { return; }

  const $ = s => document.querySelector(s);
  // Shopify returns //host/cdn/... — strip to a root-relative, same-origin path
  const toSrc = u => {
    if (!u) return '';
    const stripped = u.replace(/^https?:/, '').replace(/^\/\/[^/]+/, '');
    return stripped.startsWith('/cdn/') ? stripped : u;
  };
  const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
  const cartUrl = (window.routes && window.routes.cart_url) || '/cart';

  let toastT;
  const toast = msg => {
    const t = $('#toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastT);
    toastT = setTimeout(() => t.classList.remove('show'), 1900);
  };
  window.toast = toast;

  let opener = null, cur = 0, variantId = null;

  const show = from => {
    opener = from;
    scrim.hidden = false;
    requestAnimationFrame(() => scrim.classList.add('on'));
    drawer.classList.add('on');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('k-locked');
    drawer.querySelector('.k-dbody').scrollTop = 0;
    setTimeout(() => drawer.querySelector('[data-close]').focus(), 60);
  };

  const hide = () => {
    if (!drawer.classList.contains('on')) return;
    drawer.classList.remove('on');
    drawer.setAttribute('aria-hidden', 'true');
    scrim.classList.remove('on');
    document.body.classList.remove('k-locked');
    setTimeout(() => { scrim.hidden = true; }, 250);
    if (opener) opener.focus({ preventScroll: true });
  };

  drawer.querySelector('[data-close]').addEventListener('click', hide);
  scrim.addEventListener('click', hide);
  document.addEventListener('keydown', e => {
    if (!drawer.classList.contains('on')) return;
    if (e.key === 'Escape') hide();
    if (e.key === 'Tab') {
      const f = [...drawer.querySelectorAll('button:not([disabled]), a[href]')];
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  function openItem(i, from) {
    const it = ITEMS[i];
    if (!it) return;
    cur = i;
    variantId = null;

    $('#fImg').src = toSrc(it.img);
    $('#fImg').alt = it.title;
    $('#fTitle').textContent = it.title;
    $('#fLink').href = it.url;
    $('#fPrice').textContent = it.price;
    $('#fLab').textContent = it.option_name || 'Size';

    const onlyDefault = it.variants.length === 1 && it.variants[0].title === 'Default Title';
    const sizes = $('#fSizes');

    if (onlyDefault) {
      sizes.innerHTML = '';
      sizes.hidden = true;
      $('#fLab').hidden = true;
      if (it.variants[0].available) variantId = it.variants[0].id;
    } else {
      sizes.hidden = false;
      $('#fLab').hidden = false;
      sizes.innerHTML = it.variants.map(v =>
        `<button type="button" aria-pressed="false" data-vid="${v.id}"${v.available ? '' : ' disabled'}>${v.title}</button>`
      ).join('');
      sizes.querySelectorAll('button').forEach(b => b.addEventListener('click', () => {
        sizes.querySelectorAll('button').forEach(x => x.setAttribute('aria-pressed', 'false'));
        b.setAttribute('aria-pressed', 'true');
        variantId = b.dataset.vid;
        $('#fHint').textContent = '';
      }));
    }

    $('#fHint').textContent = it.available ? '' : 'Sold out';
    const add = $('#fAdd');
    add.disabled = !it.available;
    add.textContent = it.available ? 'Add to cart' : 'Sold out';
    show(from);
  }

  document.querySelectorAll('.k-card').forEach(c => {
    c.addEventListener('click', () => openItem(+c.dataset.i, c));
  });

  $('#fAdd').addEventListener('click', async () => {
    const it = ITEMS[cur];
    if (!variantId) {
      $('#fHint').textContent = `Choose a ${(it.option_name || 'size').toLowerCase()}`;
      return;
    }
    const add = $('#fAdd');
    add.disabled = true;
    add.textContent = 'Adding…';
    try {
      const res = await fetch(`${addUrl}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      });
      const body = await res.json();
      if (!res.ok) throw new Error(body.description || body.message || 'Could not add to cart');

      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      const badge = document.getElementById('cartN');
      if (badge) {
        badge.textContent = cart.item_count;
        badge.hidden = cart.item_count === 0;
      }
      const label = body.items ? body.items[0].variant_title : '';
      toast(`Added ${it.title}${label && label !== 'Default Title' ? ' — ' + label : ''}`);
      hide();
    } catch (err) {
      $('#fHint').textContent = err.message;
    } finally {
      add.disabled = false;
      add.textContent = 'Add to cart';
    }
  });

  function openFromHash() {
    const m = location.hash.match(/^#p=([\w-]+)/);
    if (!m) return;
    const i = ITEMS.findIndex(it => it.handle === m[1]);
    if (i < 0) return;
    history.replaceState(history.state, '', location.pathname + location.search);
    openItem(i, document.querySelectorAll('.k-card')[i]);
  }
  openFromHash();
  addEventListener('hashchange', openFromHash);
})();
